import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { 
    checkUrl: String 
  }
  
  connect() {
    console.log("CONNECTED TO THE CONTROLLER")
    this.startPolling()
  }
  
  disconnect() {
    this.stopPolling()
  }
  
  startPolling() {
    this.pollInterval = setInterval(() => {
      this.checkPaymentStatus()
    }, 3000) // Verificar a cada 3 segundos
  }
  
  stopPolling() {
    if (this.pollInterval) {
      clearInterval(this.pollInterval)
    }
  }
  
  async checkPaymentStatus() {
    try {
      const response = await fetch(`${this.checkUrlValue}`)
      const data = await response.json()
      console.log(data)
      if (data.redirect_url) {
        this.stopPolling()
        this.showRedirect()

        setTimeout(() => {
          window.location.href = data.redirect_url
        }, 2000)
      }
    } catch (error) {
      console.error('Erro ao verificar status:', error)
    }
  }
  
  showRedirect() {
    document.body.innerHTML = `
      <div id="main" class="min-h-screen bg-white flex items-center justify-center">
        <div class="text-center space-y-6">
          <!-- Loading Spinner -->
          <div class="flex justify-center">
            <div class="w-16 h-16 border-4 border-gray-200 border-t-green-600 rounded-full animate-spin"></div>
          </div>

          <!-- Loading Text -->
          <div class="space-y-2">
            <h3 class="text-xl font-semibold text-gray-800">
              Pagamento Confirmado!
            </h3>
            <p class="text-gray-600">
              Redirecionando...
            </p>
          </div>
        </div>
      </div>
    `
  }
}